export function isBlindTransferEnable(): boolean {
  const mode = process.env.MODE;
  const env = {
    development: true,
    production: true,
    staging: true,
  };

  if (mode && mode in env) {
    return env[mode as keyof typeof env];
  }

  return true; // default
}
